import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import Button from "../Button"
import WpInput from "../WpInput/WpInput"
import WpModal from "../WpModal"

export default function ConfirmDeleteModal({
  isOpen,
  toggle,
  onConfirm,
  item,
  onClosed,
  message = "",
  challenge = "",
}) {
  const { t } = useTranslation(["translation"])
  const [challengeInput, setChallengeInput] = useState("")

  return (
    <WpModal
      isOpen={isOpen}
      toggle={toggle}
      title={t("confirm_delete.title")}
      onClosed={onClosed}
    >
      <div className="d-flex flex-column">
        {message === "" && (
          <span style={{ userSelect: "none" }}>
            {t("message.delete_item", { item: item })}
          </span>
        )}
        {message !== "" && <span>{message}</span>}
        <span className="py-4">{t("message.delete_confirm")}</span>
        {challenge !== "" && (
          <div className="d-flex flex-column pb-5">
            <span className="py-4" style={{ userSelect: "none" }}>
              {t("message.challenge_delete", {challenge: challenge })}
            </span>
            <WpInput
              invalid={challengeInput !== challenge}
              onChange={(e) => setChallengeInput(e.target.value)}
            />
          </div>
        )}
        <div className="d-flex flex-row align-items-center justify-content-end">
          <Button size="sm" color="none" onClick={toggle}>
            {t("action:cancel")}
          </Button>
          <Button
            size="sm"
            color="dark"
            className="ml-8"
            disabled={challenge !== challengeInput}
            onClick={() => {
              onConfirm()
              toggle()
            }}
          >
            {t("action:confirm")}
          </Button>
        </div>
      </div>
    </WpModal>
  )
}
